import { render } from "./ShoppingHeader.vue?vue&type=template&id=5e29e9ae"
import script from "./ShoppingHeader.vue?vue&type=script&lang=js"
export * from "./ShoppingHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__